import {
  Building2,
  FileText,
  LayoutDashboard,
  Radio,
  Settings,
  UserX,
  Users,
  GraduationCap,
} from "lucide-react";

export const ADMIN_NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, testId: "nav-dashboard" },
  { to: "/admin/partners", label: "Partners", icon: Building2, testId: "nav-partners" },
  { to: "/admin/families", label: "Families", icon: Users, testId: "nav-families" },
  { to: "/admin/students", label: "Students", icon: GraduationCap, testId: "nav-students" },
  { to: "/admin/records", label: "Records", icon: FileText, testId: "nav-records" },
  { to: "/admin/live-users", label: "Live Visitors", icon: Radio, testId: "nav-live-users" },
  { to: "/admin/drop-offs", label: "Drop-Offs", icon: UserX, testId: "nav-drop-offs" },
  { to: "/admin/settings", label: "Settings", icon: Settings, testId: "nav-settings" },
];
